import { useState, useEffect } from 'react';

export const useZoomChecker = () => {
    const [isZoomedIn, setIsZoomedIn] = useState<boolean>(false);

    useEffect(() => {
        try {
            window.visualViewport.onresize = (event: Event) => {
                const viewport = (event?.target as VisualViewport)
                if (viewport) {
                    setIsZoomedIn(viewport?.scale > 1.05);
                };
            };
        } catch (exception: unknown) {
            console.error('VisualViewport/ZoomChecker error: ' + exception);
        }
    }, []);

    return isZoomedIn;
};
